<template>
	<div class="c-modal-ai-clone">
		<Modal v-model="options.active" @input="closeModal" :closable="true">
			<AiClone :ad="ad"></AiClone>
			<div class="c-spinner" v-if="processing"></div>
			<article v-if="error" class="c-modal-block-view__article article-text-lg">
				<p>Ad couldn't be loaded.</p>
			</article>
		</Modal>
	</div>
</template>

<script>
import Modal from './index.vue';
import { parseISO, format } from 'date-fns';
import api from '@swipekit/lib/api';

import AiClone from '@swipekit/components/ai-clone/index.vue';

export default {
	components: {
		Modal,
		AiClone,
	},

	data: function () {
		return {
			lock: false,
			error: false,
			options: {
				name: 'modal-block-view',
				active: false,
			},
			ad: null,
			forceRender: true,
			processing: false,
		};
	},

	props: {
		standalone: {
			type: Boolean,
			default: false,
		},
	},

	watch: {
		'options.active': {
			handler: function () {},
		},
		viewId: function () {
			this.error = false;
			if (this.viewId) {
				this.options.active = true;
				this.loadAd();
				this.lock = true;
				setTimeout(() => {
					this.lock = false;
				}, 500);
			} else {
				this.options.active = false;
			}
		},
		block: function () {
			this.forceRender = false;
			this.$nextTick(() => {
				this.forceRender = true;
			});
		},
	},

	computed: {
		sourceUrl: function () {
			let block = this.ad.block;

			if (block.source && typeof block.source === 'string') {
				return block.source;
			}

			return null;
		},
		viewCache: function () {
			return this.$store.getters['ads/viewCache'];
		},
		createdAt: function () {
			let createdAt = this.block.createdAt;
			let date = parseISO(createdAt);
			let str = format(date, `do MMM yy`);
			return str;
		},

		viewId: function () {
			return this.$store.getters['app/scriptGeneratorId'];
		},

		isInViewCache: function () {
			let viewId = this.viewId;
			if (!viewId) {
				return;
			}
			let isInViewCache = false;
			const viewCache = this.viewCache;
			for (let i = 0; i < viewCache.length; i++) {
				const a = viewCache[i];
				if (a.id === viewId) {
					isInViewCache = true;
					break;
				}
			}

			return isInViewCache;
		},
	},

	methods: {
		loadAd: async function () {
			this.ad = null;
			this.processing = true;

			const adId = this.viewId;

			if (this.viewCache) {
				let temp = null;
				for (let i = 0; i < this.viewCache.length; i++) {
					const a = this.viewCache[i];
					if (a.id === adId) {
						temp = a;
						break;
					}
				}
				if (temp) {
					this.ad = temp;
					this.processing = false;
					return;
				}
			}

			let response = null;

			if (this.standalone) {
				response = await api.api.getOne(adId);
			} else {
				response = await api.ads.getOne(adId);
			}

			if (response) {
				this.error = false;
				this.ad = response;
			} else {
				this.error = true;
			}
			this.processing = false;
		},
		onSubmit: function () {
			this.options.active = false;
		},
		activate: function () {
			this.options.active = true;
		},
		closeModal: function () {
			if (this.lock) {
				return;
			}
			this.$store.dispatch('app/setScriptGenerator', null);
		},
		afterDelete: function () {
			this.closeModal();
		},
	},

	mounted: function () {
		//this.options.active = true;
	},
};
</script>

<style lang="scss">
.c-modal-ai-clone {
	.vfm__overlay {
		background-color: hsla(var(--s), 35%, 7%, 0.75) !important;

		&.non-closable {
		}
	}
	.modal-container {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
		overflow-y: auto;
		padding: 0;
	}

	.modal-content {
		width: 1200px;
		height: 980px;
		max-height: 100%;
		margin: 0;

		//overflow: hidden;;
	}

	.modal__title {
		padding: 0;
	}

	.modal__content {
		padding: 0;
		height: 100%;
		border-radius: 10px !important;
		background-color: var(--color-bg-2);

		> .c-spinner {
			position: absolute;
			top: calc(50% - 24px);
			left: calc(50% - 24px);
			width: 48px;
			height: 48px;
			border-width: 4px;
			border-color: #000;
			border-bottom-color: transparent;
		}
	}

	&__article {
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	@media screen and (max-width: 1400px) {
		.modal-content {
			height: 92%;
			width: calc(100% - 192px);
		}
	}

	@media screen and (max-width: 996px) {
		.modal__content {
			> nav {
				display: none;
			}
		}
		.modal-content {
			width: 100%;
			height: calc(100% - 50px);
			margin-top: 50px;
			border-radius: 0;

			> svg {
				top: -42px;
				color: #fff;
			}
		}
		.modal-container {
			display: block;
		}
	}

	@media screen and (min-width: 1800px) {
		.modal-content {
			width: 1440px;
			height: 1200px;
		}
	}
}
</style>
